import { apiGet, apiPost } from './client';

export async function getPublicShowcaseTracks() {
  return apiGet('/showcase/tracks');
}

function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export async function getPublicShowcaseCases({
  query,
  partner,
  track,
  location,
  has_rewards,
  has_contacts,
  has_attachments,
  sort_by,
  sort_dir,
  limit = 12,
  offset = 0
} = {}) {
  const response = await apiGet(
    `/showcase/cases${buildQuery({
      query,
      partner,
      track,
      location,
      has_rewards,
      has_contacts,
      has_attachments,
      sort_by,
      sort_dir,
      limit,
      offset
    })}`
  );
  return response;
}

export async function getPublicShowcaseCase(caseId) {
  return apiGet(`/showcase/cases/${caseId}`);
}

export async function setCasePriority(caseId, priority) {
  return apiPost(`/me/showcase/cases/${caseId}/priority`, { priority });
}

export async function getCasePriority(caseId) {
  return apiGet(`/me/showcase/cases/${caseId}/priority`);
}

export async function getMyPriorityCases({ limit = 3 } = {}) {
  return apiGet(`/me/showcase/priority-cases${buildQuery({ limit })}`);
}
